export enum P_WITHDRAWAL_STATUS {
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    CASHED = "CASHED",
    CANCELED = "CANCELED",
    EXPIRED = "EXPIRED",
    ONAPPEAL = "ONAPPEAL",
    CONFIRMED = "CONFIRMED"
}